import { API_BASE, axiosApi } from "../config"

export interface MinKnowApiResponse {
    code: number
    message?: string
    data?: any
    servers?: any[]
    positions?: any[]
    hostInfo?: any
}

export async function getMinKnowServers(): Promise<MinKnowApiResponse> {
    return (await axiosApi.post(`${API_BASE}/minknow/servers`, {})).data
}

export async function pingMinKnowServer(serverId: string): Promise<MinKnowApiResponse> {
    return (await axiosApi.post(`${API_BASE}/minknow/ping`, { serverId })).data
}

export async function getPositions(serverId: string): Promise<MinKnowApiResponse> {
    return (await axiosApi.post(`${API_BASE}/minknow/positions`, { serverId })).data
}

export async function getProtocolRunInfo(serverId: string, position: string): Promise<MinKnowApiResponse> {
    return (await axiosApi.post(`${API_BASE}/minknow/protocol/run-info`, { serverId, position })).data
}

export async function getAcquisitionInfo(serverId: string, position: string): Promise<MinKnowApiResponse> {
    return (await axiosApi.post(`${API_BASE}/minknow/acquisition/info`, { serverId, position })).data
}

export async function getFlowCellInfo(serverId: string, position: string): Promise<MinKnowApiResponse> {
    return (await axiosApi.post(`${API_BASE}/minknow/device/flow-cell-info`, { serverId, position })).data
}

export async function startProtocol(serverId: string, position: string, params: any): Promise<MinKnowApiResponse> {
    return (await axiosApi.post(`${API_BASE}/minknow/protocol/start`, { serverId, position, ...params })).data
}

export async function stopProtocol(serverId: string, position: string, run_id?: string): Promise<MinKnowApiResponse> {
    return (await axiosApi.post(`${API_BASE}/minknow/protocol/stop`, { serverId, position, run_id })).data
}

export async function stopAcquisition(serverId: string, position: string): Promise<MinKnowApiResponse> {
    return (await axiosApi.post(`${API_BASE}/minknow/acquisition/stop`, { serverId, position })).data
}

export async function updateRunUntil(serverId: string, position: string, stop_runtime_seconds: number): Promise<MinKnowApiResponse> {
    return (await axiosApi.post(`${API_BASE}/minknow/run-until/update`, { serverId, position, stop_runtime_seconds })).data
}

export async function getBasecallConfigs(serverId: string): Promise<MinKnowApiResponse> {
    return (await axiosApi.post(`${API_BASE}/minknow/basecall-configs`, { serverId })).data
}

export async function getChannelStates(serverId: string, position: string): Promise<MinKnowApiResponse> {
    return (await axiosApi.post(`${API_BASE}/minknow/channel-states`, { serverId, position })).data
}
